/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class CertificateReceiveDetail extends Ce {
    constructor() {
        super();
        this.baseUrl += '/certificateReceiveDetail';
    }

    findCertificateReceiveDetailList({
        fullName,
        mobile,
        idCardNo,
        certificateReceiveDetailType,
        certCatId,
        certExamType,
        groupingName,
        shipMethod,
        orgId,
        companyName,
        workRegionId,
        examApplyTime,
        statusChangeTime,
        theoryExamTimeBegin,
        certificateReceiveBatchType,
        certificateReceiveStatus,
        batchIdNull,
        certificateReceiveBatchId,
        enterpriseName,
        enterpriseCooperationName,
        batchSn,
        batchName,
        expressName,
        trackingNumber,
        isPrint,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let examApplyTimeBegin = null;
        let examApplyTimeEnd = null;
        if (examApplyTime != null && examApplyTime.length === 2) {
            [examApplyTimeBegin, examApplyTimeEnd] = examApplyTime;
        }
        let statusChangeTimeBegin = null;
        let statusChangeTimeEnd = null;
        if (statusChangeTime != null && statusChangeTime.length === 2) {
            [statusChangeTimeBegin, statusChangeTimeEnd] = statusChangeTime;
        }
        let theoryExamTimeBeginBegin = null;
        let theoryExamTimeBeginEnd = null;
        if (theoryExamTimeBegin != null && theoryExamTimeBegin.length === 2) {
            [theoryExamTimeBeginBegin, theoryExamTimeBeginEnd] = theoryExamTimeBegin;
        }
        return super.get('/findCertificateReceiveDetailList', {
            fullName,
            mobile,
            idCardNo,
            certificateReceiveDetailType,
            certCatId,
            certExamType,
            groupingName,
            shipMethod,
            orgId,
            companyName,
            workRegionId,
            examApplyTimeBegin,
            examApplyTimeEnd,
            statusChangeTimeBegin,
            statusChangeTimeEnd,
            theoryExamTimeBeginBegin,
            theoryExamTimeBeginEnd,
            certificateReceiveBatchType,
            certificateReceiveStatus,
            batchIdNull,
            certificateReceiveBatchId,
            enterpriseName,
            enterpriseCooperationName,
            batchSn,
            batchName,
            expressName,
            trackingNumber,
            isPrint,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/getDetail', { id });
    }

    backWaitConfirm({ id }) {
        return super.post('/backWaitConfirm', { id });
    }

    relatedBatch({ ids, certificateReceiveBatchId }) {
        return super.post('/relatedBatch', { ids, certificateReceiveBatchId });
    }

    removeBatch({ ids }) {
        return super.post('/removeBatch', { ids });
    }

    createEmsOrder(param) {
        return super.post('/createEmsOrder', { ...param });
    }

    getLodopPrintInfo(param) {
        return super.get('/getLodopPrintInfo', { ...param });
    }

    updatePrintStatus(param) {
        return super.post('/updatePrintStatus', { ...param });
    }

    sendConfirmMessage({ ids }) {
        return super.post('/sendConfirmMessage', { ids });
    }

    confirmShipMethod({ ids, deliveryConsignee, deliveryPhone, deliveryRegionId, deliveryAddress, shipMethod }) {
        return super.post('/confirmShipMethod', {
            ids,
            deliveryConsignee,
            deliveryPhone,
            deliveryRegionId,
            deliveryAddress,
            shipMethod,
        });
    }
}

export default new CertificateReceiveDetail();
export { CertificateReceiveDetail };
